// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605290402/js/" + chunkId + "." + {"44":"179ced18","225":"6e79a978","481":"52b07fbe","486":"db058106","770":"7999e033"}[chunkId] + ".0.1654477314163576.chunk.js";
};